module.exports = __webpack_public_path__ + "img/qrcode-ego.f76afab5.png";